import { withErrorBoundary } from '../dependencies';

import ListRecurring from '../components/ListRecurring';

export default withErrorBoundary(ListRecurring);
